/* ROCKBROS NL | Black Friday full-collection search V1. Default native Shopify grid stays until index succeeds. */
(()=>{
 if(window.__rbnlBlackFridayFullCatalogV1)return;
 window.__rbnlBlackFridayFullCatalogV1=true;
 const normalize=v=>String(v||'').toLocaleLowerCase('nl-NL').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/\s+/g,' ').trim();
 const readableMoney=(cents,iso)=>new Intl.NumberFormat('nl-NL',{style:'currency',currency:iso||'EUR'}).format(Number(cents||0)/100);
 const discount=p=>Number(p.compare)>Number(p.price)&&Number(p.compare)>0?Math.round((Number(p.compare)-Number(p.price))*100/Number(p.compare)):0;
 const classify=p=>{
  const type=normalize(p.type),other=normalize([p.primary,p.secondary,p.title].join(' '));
  if(/^(kinderfietsen|gravelfietsen|racefietsen|vouwfietsen|mountainbikes|fietsen|elektrische fietsen|stadsfietsen)$/.test(type))return 'bikes';
  if(/standaard|standaard|stalling|fietsenrek|workstand|reparatiestand/.test(type))return 'stands';
  if(/verlichting|lamp|achterlicht|voorlicht|fietslamp|reflector/.test(type))return 'lights';
  if(/fietsslot|slot|locks|chain lock/.test(type))return 'locks';
  if(/tas|tassen|rugzak|bag|koeltas|bikepacking/.test(type))return 'bags';
  if(/gereedschap|tool|pomp|reparatie|momentsleutel|bandenlichter/.test(type))return 'tools';
  if(/shirt|broek|gilet|jas|jacks|handschoen|bivak|balaclava|muts|pant|vest|kleding|helm|bril|nekwarmer|sokken|overschoen|armstukken|hoofdband/.test(type))return 'apparel';
  if(other.includes('fietstassen')&&/tas|bag/.test(normalize(p.secondary)))return 'bags';
  return 'other';
 };
 const active=(state)=>!!(state.force||state.q.trim()||state.cat!=='all'||state.discount!=='all'||state.price!=='all'||state.stock||state.sort!=='popular');
 function mount(root){
  if(root.dataset.ready==='1')return;root.dataset.ready='1';
  const find=s=>root.querySelector(s);
  const input=find('[data-bfc-search]'),clear=find('[data-bfc-search-clear]'),status=find('[data-bfc-status]'),results=find('[data-bfc-results]'),count=find('[data-bfc-results-count]'),grid=find('[data-bfc-grid]'),empty=find('[data-bfc-empty]'),more=find('[data-bfc-load-more]'),advanced=find('[data-bfc-more-panel]'),toggle=find('[data-bfc-more]'),stock=find('[data-bfc-stock]'),sort=find('[data-bfc-sort]');
  const native=root.querySelector('[data-bfc-native-fallback]')||document.querySelector('[id$="__bf_all_products"]');
  const pageSize=Number(root.dataset.pageSize)||24;
  const iso=root.dataset.currency||'EUR';
  const state={q:'',cat:'all',discount:'all',price:'all',stock:false,sort:'popular',limit:pageSize,force:root.dataset.bfcMode==='page'};
  let fullIndex=null,fullPromise=null,filtered=[],seq=0,typing=null,lastY=window.scrollY;
  const setStatus=s=>{status.textContent=s};
  function source(page){
    const u=new URL(root.dataset.collection,location.origin);
    u.searchParams.set('view','bf-catalog-index');
    u.searchParams.set('page',String(page));
    // Shopify strips preview_theme_id from the visible URL after setting a theme-preview cookie.
    // AJAX requests still need to target this unpublished theme explicitly, otherwise they
    // silently return the published theme's normal collection HTML instead of JSON.
    const queryPreview=new URLSearchParams(location.search).get('preview_theme_id');
    const currentTheme=window.Shopify?.theme;
    const role=String(currentTheme?.role||'').toLowerCase();
    const livePreview=role&&role!=='main'&&currentTheme?.id?String(currentTheme.id):null;
    const preview=queryPreview||livePreview;
    if(preview && /^\d+$/.test(String(preview)))u.searchParams.set('preview_theme_id',String(preview));
    return u.href;
  }
  async function fetchPage(page,attempt=0){
    try{
      const response=await fetch(source(page),{credentials:'same-origin'});
      if(!response.ok)throw Error('http '+response.status);
      const value=JSON.parse(await response.text());
      if(value.view!=='bf-catalog-index-v2'||!Array.isArray(value.products)||!value.pages)throw Error('Invalid catalog index for page '+page);
      return value;
    }catch(error){
      if(attempt<2){await new Promise(resolve=>setTimeout(resolve,500*(attempt+1)));return fetchPage(page,attempt+1);}
      throw error;
    }
  }
  async function ensureFullIndex(){
    if(fullIndex)return fullIndex;
    if(fullPromise)return fullPromise;
    fullPromise=(async()=>{
      const first=await fetchPage(1);
      if(first.pages>20)throw Error('Unexpected catalog size');
      const all=[...first.products];
      for(let page=2;page<=first.pages;page+=2){
        const tasks=[];
        for(let idx=page;idx<Math.min(first.pages+1,page+2);idx++)tasks.push(fetchPage(idx));
        const chunks=await Promise.all(tasks);
        chunks.forEach(c=>all.push(...c.products));
        setStatus('Producten worden geladen… '+all.length+' / '+first.total);
      }
      const unique=new Map();
      for(const p of all){
        if(!p?.handle)continue;
        p._search=normalize([p.title,p.type,p.primary,p.secondary,p.tags,p.skus].join(' '));
        p._category=classify(p);
        p._discount=discount(p);
        unique.set(String(p.id),p);
      }
      fullIndex=[...unique.values()];
      return fullIndex;
    })().catch(e=>{fullPromise=null;throw e});
    return fullPromise;
  }
  function match(p){
    if(state.q){const words=normalize(state.q).split(/\s+/).filter(Boolean);if(!words.every(w=>p._search.includes(w)))return false;}
    if(state.cat!=='all'&&state.cat!==p._category)return false;
    if(state.discount!=='all'){
      const n=p._discount;
      if(n<=0)return false;
      const groups={'0-15':n>0&&n<15,'15-25':n>=15&&n<25,'25-35':n>=25&&n<35,'35-45':n>=35&&n<45,'45-plus':n>=45};
      if(!groups[state.discount])return false;
    }
    if(state.price!=='all'){
      const value=Number(p.price)/100;
      const groups={'0-20':value<20,'20-40':value>=20&&value<40,'40-80':value>=40&&value<80,'80-plus':value>=80};
      if(!groups[state.price])return false;
    }
    if(state.stock&&!p.available)return false;
    return true;
  }
  function filteredIndex(){
    const list=fullIndex.filter(match);
    if(state.sort==='price-low')list.sort((a,b)=>Number(a.price)-Number(b.price));
    else if(state.sort==='price-high')list.sort((a,b)=>Number(b.price)-Number(a.price));
    else if(state.sort==='discount')list.sort((a,b)=>b._discount-a._discount);
    return list;
  }
  function renderProduct(p){
    const li=document.createElement('li');li.className='bfc-product';
    const media=document.createElement('div');media.className='bfc-product__media';
    const imageBtn=document.createElement('button');imageBtn.type='button';imageBtn.className='bfc-product__image-button';imageBtn.dataset.bfcOpen=p.handle;imageBtn.setAttribute('aria-label',p.title+' snel bekijken');
    if(p.image){const img=document.createElement('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.decoding='async';imageBtn.append(img);}
    media.append(imageBtn);
    if(p._discount>0){const badge=document.createElement('span');badge.className='bfc-product__badge';badge.textContent='−'+p._discount+'% KORTING';media.append(badge)}
    li.append(media);
    const body=document.createElement('div');body.className='bfc-product__body';
    const typ=document.createElement('span');typ.className='bfc-product__type';typ.textContent=p.secondary||p.type||'';body.append(typ);
    const title=document.createElement('button');title.type='button';title.className='bfc-product__title';title.dataset.bfcOpen=p.handle;title.textContent=p.title;body.append(title);
    const price=document.createElement('div');price.className='bfc-product__price';
    const curr=document.createElement('strong');curr.textContent=readableMoney(p.price,iso);price.append(curr);
    if(p._discount>0){const was=document.createElement('s');was.textContent=readableMoney(p.compare,iso);price.append(was);}
    body.append(price);
    const preview=document.createElement('button');preview.type='button';preview.className='bfc-product__preview';preview.dataset.bfcOpen=p.handle;
    const label=document.createElement('span');label.textContent=Number(p.variantCount)>1?'Kies je uitvoering':'Snel bekijken';
    const arr=document.createElement('span');arr.setAttribute('aria-hidden','true');arr.textContent='↗';preview.append(label,arr);body.append(preview);li.append(body);
    return li;
  }
  function render(){
    grid.replaceChildren();
    const portion=filtered.slice(0,state.limit);
    const fragment=document.createDocumentFragment();
    for(const product of portion)fragment.append(renderProduct(product));
    grid.append(fragment);
    count.textContent=String(filtered.length);
    empty.hidden=filtered.length>0;
    more.hidden=portion.length>=filtered.length;
    results.hidden=false;
  }
  function updatePressed(){
    root.querySelectorAll('[data-bfc-cat]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bfcCat===state.cat)));
    root.querySelectorAll('[data-bfc-discount]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bfcDiscount===state.discount)));
    root.querySelectorAll('[data-bfc-price]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.bfcPrice===state.price)));
    clear.hidden=!state.q;
  }
  async function apply(){
    updatePressed();
    state.limit=pageSize;
    const token=++seq;
    if(!active(state)){
      results.hidden=true;
      if(native){native.hidden=false;native.style.removeProperty('display');}
      setStatus('');
      return;
    }
    setStatus('Zoeken in alle Black Friday-producten…');
    try{
      await ensureFullIndex();
      if(token!==seq||!active(state))return;
      filtered=filteredIndex();
      if(native){native.hidden=true;native.style.display='none';}
      render();setStatus('');
    }catch(e){
      if(token!==seq)return;
      results.hidden=true;
      if(native){native.hidden=false;native.style.removeProperty('display');}
      setStatus('Zoeken is tijdelijk niet beschikbaar. Gebruik de productfilters hieronder.');
      console.warn('[ROCKBROS BF catalog] index unavailable',e);
    }
  }
  function reset(){
    state.q='';state.cat='all';state.discount='all';state.price='all';state.stock=false;state.sort='popular';
    input.value='';stock.checked=false;sort.value='popular';
    updatePressed();apply();
  }
  const debounced=()=>{clearTimeout(typing);typing=setTimeout(()=>{state.q=input.value;apply();},230)};
  input.addEventListener('input',()=>{clear.hidden=!input.value;debounced();});
  clear.addEventListener('click',()=>{input.value='';state.q='';clear.hidden=true;apply();input.focus()});
  root.addEventListener('click',e=>{
    const cat=e.target.closest('[data-bfc-cat]');
    if(cat){state.cat=cat.dataset.bfcCat;apply();return;}
    const disc=e.target.closest('[data-bfc-discount]');
    if(disc){state.discount=disc.dataset.bfcDiscount;apply();return;}
    const price=e.target.closest('[data-bfc-price]');
    if(price){state.price=price.dataset.bfcPrice;apply();return;}
    const trigger=e.target.closest('[data-bfc-open]');
    if(trigger){const handle=trigger.dataset.bfcOpen;const p=fullIndex?.find(item=>item.handle===handle);
      if(!handle||!(/^[a-z0-9][a-z0-9-]*$/i.test(handle)))return;
      const u=new URL(p?.url||'/products/'+encodeURIComponent(handle),location.origin);
      if(u.origin!==location.origin)return;
      if(p.variantId)u.searchParams.set('variant',String(p.variantId));
      if(window.RbnlQuickView?.open)window.RbnlQuickView.open(root,u.href,trigger);
      else location.assign(u.href);
      return;
    }
  });
  find('[data-bfc-more]').addEventListener('click',()=>{
    advanced.hidden=!advanced.hidden;
    toggle.setAttribute('aria-expanded',String(!advanced.hidden));
    if(window.innerWidth<750)root.classList.remove('is-scroll-compact');
  });
  find('[data-bfc-reset]').addEventListener('click',reset);
  stock.addEventListener('change',()=>{state.stock=stock.checked;apply()});
  sort.addEventListener('change',()=>{state.sort=sort.value;apply()});
  more.addEventListener('click',()=>{state.limit+=pageSize;render()});
  window.addEventListener('scroll',()=>{
    if(window.innerWidth>=750)return;
    const y=window.scrollY,diff=y-lastY;lastY=y;
    if(Math.abs(diff)<18)return;
    const box=root.getBoundingClientRect();
    if(box.top<100&&box.bottom>160)root.classList.toggle('is-scroll-compact',diff>0&&advanced.hidden);
    else root.classList.remove('is-scroll-compact');
  },{passive:true});
  window.addEventListener('resize',()=>{if(window.innerWidth>=750)root.classList.remove('is-scroll-compact')},{passive:true});
  if(state.force)apply();
 }
 const start=scope=>{
   if(scope?.matches?.('[data-bfc]'))mount(scope);
   scope?.querySelectorAll?.('[data-bfc]').forEach(mount);
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(document),{once:true});
 else start(document);
 document.addEventListener('shopify:section:load',e=>start(e.target));
})();